import React, { Suspense, lazy } from 'react';
import LoadingSpinner from "../components/V1/LoadingSpinner";



const simulateLazyLoad = (importFunc) => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(importFunc()), 1000); // Simulasi delay 1 detik
  });
};

// Lazy loading untuk komponen
const Navbar = lazy(() => simulateLazyLoad(() => import("../components/V2/Navbar")));
const Footer = lazy(() => simulateLazyLoad(() => import("../components/V2/Footer")));
const Aboutus = lazy(() => simulateLazyLoad(() => import("../components/V2/Aboutus")));
const VisiMisi = lazy(() => simulateLazyLoad(() => import("../components/V2/VisiMisi")));
const PerjalananMisi = lazy(() => simulateLazyLoad(() => import("../components/V2/PerjalananMisi")));


function TentangKami() {
  return (
    <div className='space-y-20 overflow-hidden'>
      <Suspense fallback={<LoadingSpinner />}>
        <Navbar />
        <Aboutus/>
        <VisiMisi/>
        <PerjalananMisi/>
        <Footer/>
      </Suspense>
    </div>
  );
}

export default TentangKami;

